'use strict';

/**
 * @classname AreaManager
 * @classdesc エリアマネージャースライダー
 */
export default class AreaManager {
	/**
	 * @constructor
	 * @param {jQuery} $e - .area-manager-slide
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		let options = {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 30,
			centeredSlides: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 2.5,
				},
				1200: {
					slidesPerView: 3,
				}
			}
		}
		console.log(options);
		const swiper = new Swiper('.area-manager-slide', options);
	};
};
